"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const EPaymentMethod_1 = require("../../enums/ProductSubscribed/EPaymentMethod");
const ClientSheetLightResponseResource_1 = __importDefault(require("../ClientSheet/ClientSheetLightResponseResource"));
const ProductSheetResponseResource_1 = __importDefault(require("../ProductSheet/ProductSheetResponseResource"));
const Resource_1 = __importDefault(require("../Resource"));
const SubscriptionResponseResource_1 = __importDefault(require("../Subscription/SubscriptionResponseResource"));
const ProductSubscribedToFileResponseResource_1 = __importDefault(require("./File/ProductSubscribedToFileResponseResource"));
const CorporationSheetLightResponseResource_1 = __importDefault(require("../CorporationSheet/CorporationSheetLightResponseResource"));
const ProductSubscribedAnomalyReport_1 = __importDefault(require("./ProductSubscribedAnomalyReport"));
class ProductSubscribedResponseResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.titularyName = null;
        this.bankDomiciliation = null;
        this.iban = null;
        this.bic = null;
        this.organismName = null;
        this.submittedAt = null;
        this.validationDate = null;
        this.productSubscribedToFiles = [];
    }
}
exports.default = ProductSubscribedResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSubscribedResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProductSheetResponseResource_1.default),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "productSheet", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "subscriberId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ClientSheetLightResponseResource_1.default),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "subscriber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "corporationSubscriberId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => CorporationSheetLightResponseResource_1.default),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "corporationSubscriber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSubscribedResponseResource.prototype, "subscriptionId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SubscriptionResponseResource_1.default),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "subscription", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "step", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ProductSubscribedResponseResource.prototype, "quantity", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_transformer_1.Transform)(({ obj }) => Number(obj["unitPriceAtSubscription"] ?? obj["legacyTransaction"]?.unitPrice ?? obj["productSheet"]?.price ?? 0)),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "unitPriceAtSubscription", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_transformer_1.Transform)(({ obj }) => Number(obj["amountAtSubscription"] ?? obj["legacyTransaction"]?.amount ?? Number(obj["quantity"] ?? 0) * Number(obj["productSheet"]?.price ?? 0))),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "amountAtSubscription", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_transformer_1.Transform)(({ obj }) => Number(obj["amountAtSubscription"] ?? obj["legacyTransaction"]?.amount ?? Number(obj["quantity"] ?? 0) * Number(obj["productSheet"]?.price ?? 0))),
    __metadata("design:type", Number)
], ProductSubscribedResponseResource.prototype, "amount", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ obj }) => Boolean(obj["legacyTransaction"])),
    __metadata("design:type", Boolean)
], ProductSubscribedResponseResource.prototype, "isLegacy", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ obj }) => ["paid", "confirmed"].includes(obj["legacyTransaction"]?.sourceStatus)),
    __metadata("design:type", Boolean)
], ProductSubscribedResponseResource.prototype, "legacyReadOnly", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSubscribedResponseResource.prototype, "paymentMethod", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "titularyName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "bankDomiciliation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "iban", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "bic", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "organismName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "nantieParts", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "loanAmount", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "manuallyTransferToSGAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "submittedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "validationDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "updatedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "sgTransmittedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProductSubscribedToFileResponseResource_1.default),
    __metadata("design:type", Array)
], ProductSubscribedResponseResource.prototype, "productSubscribedToFiles", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "documentsValidatedStatus", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "subscriptionProductType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "demembrementType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "demembrementDuration", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "viagerAge", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "contrepartieNom", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProductSubscribedAnomalyReport_1.default),
    __metadata("design:type", Object)
], ProductSubscribedResponseResource.prototype, "anomalyReport", void 0);
